// pour charger des versions différentes de langues de momentjs;
// voir ligne 'new webpack.ContextReplacementPlugin(/moment[\/\\]locale$/; /fr|en/);' des fichiers webpack.config.dev (ou prod)
export const DEFAULT_LOCALE = 'nl';
//LOCALES= ['fr', 'en', 'nl'];
export const LOCALES = [DEFAULT_LOCALE, 'fr'];



// WEBPACK FOOTER //
// ./src/constants/locale.js